/**
 * Tools twiks for contact form 7
 * - spam prevention
 */
export class ContactForm7Tools {

	/**
	 * Constructor
	 *
	 * @return {void}
	 */
	constructor() {

		this.init();

		if ( this.antiSpamInput.length ) {

			document.body.addEventListener( 'mousemove', ( e ) => {

				this.validateActivityMouseMove( e );

			}, false );
			document.body.addEventListener( 'touchmove', ( e ) => {

				this.validateActivityMouseMove( e.touches[ 0 ] );

			}, false );

		}

		this.forms.forEach( ( form ) => {

			form.addEventListener( 'submit', ( e ) => {

				this.validateActivityTime( e );

			}, false );

		} );

	}

	/**
	 * Initializes components
	 */
	init() {

		this.forms = document.querySelectorAll( 'form' );
		this.antiSpamInput = document.querySelectorAll( '[name=antiSpamPoz]' );
		this.lastPosition = null;
		this.totalDistanceTraveled = 0;
		this.loadedTime = new Date().getTime();

	}

	/**
	 * Validates user activity by tracking the distance the mouse has moved and updates the value of the anti-spam input fields.
	 *
	 * @param {MouseEvent} e The mousemove event object.
	 */
	validateActivityMouseMove( e ) {

		let clientX, clientY;

		if ( e.touches ) { // if touch event

			clientX = e.touches[ 0 ].clientX;
			clientY = e.touches[ 0 ].clientY;

		} else { // if mouse event

			clientX = e.clientX;
			clientY = e.clientY;

		}

		if ( this.lastPosition !== null ) {

			const dx = clientX - this.lastPosition.x;
			const dy = clientY - this.lastPosition.y;
			this.totalDistanceTraveled += Math.sqrt( ( dx * dx ) + ( dy * dy ) );

		}

		this.lastPosition = { x: clientX, y: clientY };
		this.antiSpamInput.forEach( ( input ) => {

			input.value = Math.floor( this.totalDistanceTraveled );

		}, false );

	}

	/**
	 * Validates form submission time and updates the hidden anti-spam input field with current and load times.
	 *
	 * @param {Event} e The submit event object.
	 */
	validateActivityTime( e ) {

		const form = e.target;

		const currentTime = new Date().getTime();

		const antiSpamInput2 = form.querySelector( '[name="antiSpamTim"]' );
		if ( antiSpamInput2 ) {

			antiSpamInput2.value = `${ this.loadedTime },${ currentTime }`;

		}

	}

}
